import { v4 as uuid } from "uuid";
import { toJSON } from "./utils";
export class BaseIdOnly {
    constructor(params) {
        this.id = (params === null || params === void 0 ? void 0 : params.id) || uuid();
    }
    get json() {
        return toJSON(this);
    }
}
export class Base extends BaseIdOnly {
    constructor(params) {
        super(params);
        this.createdAt = Number((params === null || params === void 0 ? void 0 : params.createdAt) || new Date().valueOf());
        this.updatedAt = Number((params === null || params === void 0 ? void 0 : params.updatedAt) || new Date().valueOf());
    }
}
